export const getTitleId = (title) => title
    .toLowerCase()
    .replace(/[^a-zA-Z0-9]+/g, "-")
    .replace(/^-/, "")
    .replace(/-$/, "");
